<div style="margin-top: 5px; display: inline;block-size: 10%;"> 
  <div class="col-md-12" style="padding: 16px;">
    <div class="row">
      <div class="col-md-5" style="padding: 0px;">
        <h2 class="ng-binding" style="font-size: 30px;">Purchase Planning</h2>
         </div>
          <div class="col-md-7" style="text-align: right; padding: 0px;">   
            <span class="btn btn-orange" style="line-height: 33px !important; margin-right: 2%;
             padding: 5px 10px; font-size: 13px !important;color:#fff; border: 1px solid #e88421;  background:#e88421;  border-radius: 25px;padding: 0px 15px;">
            <span style="margin-right: 5px;"><i  
              aria-hidden="true" class="zmdi zmdi-plus"
              style="font-size: 16px;position: relative;top: 1px;"></i>
               </span><span >Create Job</span></span>
                <span class="btn btn-yellow" style="line-height: 33px !important; margin-right: 2%;
                 padding: 5px 10px; font-size: 13px !important;color:#fff; background:
                #E1A730; border-radius: 25px;padding: 0px 15px;">
                  <span style="margin-right: 5px;"><i 
                   aria-hidden="true" class="zmdi zmdi-plus"
                    style="font-size: 16px;position: relative;top: 1px;"></i>
                     </span><span >Create PO</span></span> 
                    <span class="btn-blue" style="margin-right: 1.5%;" (click)="exportToExcel()">
                   <i aria-hidden="true" class="fa fa-file-excel-o" title="Export to Excel" style="font-size: 16px;
                   cursor: pointer; line-height: 20px; text-decoration: none;
                  position: relative; padding: 5px 4px;"></i></span>
                 <span  (click)="refresh()" _ngcontent-buo-c0="" class="btn lableBtnDarkBlue menubottomBtn" 
                style=" padding: 7px 13px !important; border-radius: 50%; vertical-align: middle; 
               font-size: 13px; margin: 0px 0px; background: #1f628e33 !important; 
             color: #1f628e " title="Refresh"><i _ngcontent-buo-c0="" 
            class="fa fa-refresh"
           style="display: inline-block;color:#1f628e !important"></i></span>
           <span class="btn-blue" style="font-size: 13px; display: inline-block; padding: 4px 12px 4px; font-size: 15px; margin-left: 10px;" (click)="backBtn()">
            <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Inventory
          </span>
         </div>    
        </div>      
      </div>
    </div> 

    <div class="container">
      <div class="row">
        <div class="col-md-3">
          <input class="form-control" placeholder="Select Product">
          <datalist >
            <option  value="LedgerName">LedgerName</option>
            <option  value="item">item</option>
            <option  value="category">category</option>
            <option  value="room">room</option>
            <option  value="food">food</option>
          </datalist>
        </div>
        <div class="col-md-3">
          <input class="form-control" placeholder="Select Jobs">
          <datalist >
            <option  value="LedgerName">LedgerName</option>
            <option  value="item">item</option>
            <option  value="category">category</option>
            <option  value="room">room</option>
            <option  value="food">food</option>
          </datalist>
        </div>
        <div class="col-md-3">
            <label>Next :</label>
            <input style="width: 45px; margin-left: 2%; border-bottom: 1px solid #BCC2C9 !important; border-top: none; border-left: none; border-right: none; " class="days" type="text">
            <label style="margin-left: 0.5%;">days</label>
        </div>
      </div>
    </div>

<div class="wrapper" style=" overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" #purchaseprtable>
    <table mat-table [dataSource]="dataSource">
     
      <ng-container matColumnDef="material">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label>Material</label>
        </th>
        <td mat-cell *matCellDef="let element"> {{element.material}} </td>
      </ng-container>
  
      <ng-container matColumnDef="code">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label> Code</label>
        </th>
        <td mat-cell *matCellDef="let element"> {{element.code}}  </td>
      </ng-container>
    
      <ng-container matColumnDef="category">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label>Category</label>
        </th>
        <td mat-cell *matCellDef="let element">  {{element.category}} </td>
      </ng-container>

      <ng-container matColumnDef="required">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label>Required</label>
        </th>
        <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.required}} </td>
      </ng-container>

      <ng-container matColumnDef="stock">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label>Stock</label>
        </th>
        <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.stock}} </td>
      </ng-container>

      <ng-container matColumnDef="incoming">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label>Incoming</label>
        </th>
        <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.incoming}} </td>
      </ng-container>

      <ng-container matColumnDef="WIP">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label>WIP</label>
        </th>
        <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.WIP}} </td>
      </ng-container>

      <ng-container matColumnDef="unplanned">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label>Unplanned</label>
        </th>
        <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.unplanned}} </td>
      </ng-container>

      <ng-container matColumnDef="unit">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label>Unit</label>
        </th>
        <td mat-cell *matCellDef="let element"> {{element.unit}} </td>
      </ng-container>
    
      <ng-container matColumnDef="leadtime">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label>Lead Time</label>
        </th>
        <td mat-cell *matCellDef="let element"> {{element.leadtime}} {{element.leadtime == 1 ? 'day' : 'days'}} </td>
      </ng-container>

      <ng-container matColumnDef="mark">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label> </label>
        </th>
        <td mat-cell *matCellDef="let element"> <i style="cursor: pointer;" 
            class="fa fa-bookmark blueText"></i> </td>
      </ng-container>

    
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
   <!-- Angular 8 pagination -->
   <mat-paginator
        [pageSizeOptions]="[5, 10, 15]" showFirstLastButtons>
   </mat-paginator>
</div>
  